import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { configService } from '../services/config';
import type { UpdateConfigInput } from '../types/entities';
import { toast } from 'sonner';
import { apiClient } from '../services/api';

export function useConfig() {
  return useQuery({
    queryKey: ['config'],
    queryFn: () => configService.get(),
  });
}

export function useUpdateConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateConfigInput) => configService.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['config'] });
      toast.success('Configuration mise à jour');
    },
    onError: (error) => {
      toast.error(apiClient.getErrorMessage(error));
    },
  });
}
